import script from "./NoCurrentlyReadingDocsBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoCurrentlyReadingDocsBlock.vue?vue&type=script&setup=true&lang=ts"

import "./NoCurrentlyReadingDocsBlock.vue?vue&type=style&index=0&id=199d1174&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-199d1174"]])

export default __exports__